import axios from "axios";
import { getThreads as gT, getContent as gC } from '../database/database';


const sendRequest = () => {
  return {
    type: "SEND_REQUEST"
  };
};

const getThreadsSuccess = (json) => {
  return {
    type: "GET_THREADS_SUCCESS",
    payload: {
      threads: json,
    }
  };
};

const getThreadsFailure = (error) => {
  return {
    type: "GET_THREADS_FAILURE",
    payload: {
      error
    }
  };
};

const getContentsSuccess = (json) => {
  return {
    type: "GET_CONTENTS_SUCCESS",
    payload: {
      contents: json,
    }
  };
};

const getContentsFailure = (error) => {
  return {
    type: "GET_CONTENTS_FAILURE",
    payload: {
      error
    }
  };
};

const postRequestSuccess = () => {
  return {
    type: "POST_REQUEST_SUCCESS"
  };
};

const postRequestFailure = (error) => {
  return {
    type: "POST_REQUEST_FAILURE",
    payload: {
      error
    }
  };
};

// dummy
export const getThreads = () => {
  return (dispatch) => {
    dispatch(sendRequest());
    dispatch(getThreadsSuccess(gT()));
  };
};
export const getContents = (id) => {
  return (dispatch) => {
    dispatch(sendRequest());
    dispatch(getContentsSuccess({[id]: gC(id)}));
  };
};
// use API
/*
export const getThreads = () => {
  return (dispatch) => {
    dispatch(sendRequest());
    return axios.get("/keijiban/threads", {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => dispatch(getThreadsSuccess(res.data)))
      .catch(err => dispatch(getThreadsFailure(err.response)));
  };
}

export const getContents = (id) => {
  return (dispatch) => {
    dispatch(sendRequest());
    return axios.get("http://540c5374.ngrok.io/keijiban/contents", { threadId: id })
      .then(res => dispatch(getContentsSuccess({[id]: res.data})))
      .catch(err => dispatch(getContentsFailure(err.response)));
  };
}
*/

const postRequest = (url, body) => {
  return (dispatch) => {
    dispatch(sendRequest());
    return axios(url, body)
      .then(res => dispatch(postRequestSuccess(res.data)))
      .catch(err => dispatch(postRequestFailure(err)));
  };
}

